"use client";

import Link from "next/link";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { FileQuestion, Home, ArrowLeft, Search } from "lucide-react";

export default function DashboardNotFound() {
  return (
    <div className="flex items-center justify-center min-h-[calc(100vh-200px)] p-4">
      <Card className="w-full max-w-lg">
        <CardContent className="pt-10 pb-8">
          <div className="flex flex-col items-center text-center space-y-6">
            {/* Icon */}
            <div className="rounded-full bg-info/10 dark:bg-blue-900/20 p-5">
              <FileQuestion className="h-12 w-12 text-info dark:text-info" />
            </div>

            {/* Error Code */}
            <div>
              <h1 className="text-5xl font-bold text-gray-900 dark:text-gray-50 mb-2">
                404
              </h1>
              <h2 className="text-xl font-semibold text-gray-700 dark:text-gray-300">
                Page Not Found
              </h2>
            </div>

            {/* Description */}
            <p className="text-gray-600 dark:text-gray-400 max-w-md">
              The page you&apos;re looking for doesn&apos;t exist in your
              dashboard. It may have been moved or deleted.
            </p>

            {/* Actions */}
            <div className="flex flex-col sm:flex-row gap-3 w-full pt-4">
              <Link href="/dashboard" className="flex-1">
                <Button className="w-full" size="lg">
                  <Home className="h-4 w-4 mr-2" />
                  Go to Dashboard
                </Button>
              </Link>
              <Button
                variant="outline"
                className="flex-1"
                size="lg"
                onClick={() => window.history.back()}
              >
                <ArrowLeft className="h-4 w-4 mr-2" />
                Go Back
              </Button>
            </div>

            {/* Quick Links */}
            <div className="pt-6 border-t border-gray-200 dark:border-gray-700 w-full">
              <p className="text-sm text-gray-600 dark:text-gray-400 mb-3">
                Explore these sections:
              </p>
              <div className="grid grid-cols-2 gap-2">
                <Link href="/jobs">
                  <Button variant="ghost" size="sm" className="w-full">
                    Jobs
                  </Button>
                </Link>
                <Link href="/clients">
                  <Button variant="ghost" size="sm" className="w-full">
                    Clients
                  </Button>
                </Link>
                <Link href="/schedule">
                  <Button variant="ghost" size="sm" className="w-full">
                    Schedule
                  </Button>
                </Link>
                <Link href="/invoices">
                  <Button variant="ghost" size="sm" className="w-full">
                    Invoices
                  </Button>
                </Link>
                <Link href="/quotes">
                  <Button variant="ghost" size="sm" className="w-full">
                    Quotes
                  </Button>
                </Link>
                <Link href="/dashboard">
                  <Button variant="ghost" size="sm" className="w-full">
                    Dashboard
                  </Button>
                </Link>
              </div>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
